import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["checked"],
  _excluded2 = ["checked", "onClick"];
let _ = t => t,
  _t,
  _t2,
  _t3;
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const PreviewCardTimestampWrapper = styledWithTheme.div(_t || (_t = _`
  color: ${0} !important;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  margin-left: 2px;
`), ({
  theme
}) => theme.color['text-core-subtle']);
export const PreviewCardIconAvatarWrapper = styledWithTheme.div(_t2 || (_t2 = _`
  ${0}
`), ({
  checked
}) => checked && `
      display: none !important;
    `);
export const PreviewCardIconAvatar = _ref => {
  let {
      checked
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(PreviewCardIconAvatarWrapper, {
      checked: checked,
      children: /*#__PURE__*/_jsx(IconCircle, Object.assign({}, props))
    })
  );
};
PreviewCardIconAvatar.displayName = 'PreviewCardIconAvatar';
export const PreviewCardCheckboxWrapper = styledWithTheme.div(_t3 || (_t3 = _`
  margin: 5px;
  ${0}
`), ({
  checked
}) => checked && `
      &&& {
        display: block !important;
      }
    `);
export const PreviewCardCheckbox = _ref2 => {
  let {
      checked,
      onClick
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(PreviewCardCheckboxWrapper, {
      checked: checked,
      children: /*#__PURE__*/_jsx(Checkbox, Object.assign({
        checked: checked,
        onClick: onClick
      }, props))
    })
  );
};
PreviewCardCheckbox.displayName = 'PreviewCardCheckbox';